var map = {
	"./UMKC-logo.png": "1569",
	"./USC_Pharmacy_logo_horizontal_CMYK_2C.jpg": "e050",
	"./appalachian-college-of-pharmacy-logo.png": "bcfb",
	"./duquesne-university-logo.png": "88bf",
	"./famu-logo.png": "c72a",
	"./hampton-logo.jpg": "fb6a",
	"./lipscomb-logo.png": "986a",
	"./manchester-university-logo.png": "03d4",
	"./mercer-university-logo.png": "bce9",
	"./musc-logo.png": "513c",
	"./orange-spirit-mark.png": "9929",
	"./samford-university.png": "2be5",
	"./texas-tech-logo.png": "27f5",
	"./uconn-school-of-pharmacy.png": "fa84",
	"./umn-college-of-pharmacy-logo.png": "a424",
	"./uni-logo-21577-sm.png": "0cfb4",
	"./university-at-buffalo-logo.png": "5f51",
	"./university-of-hawaii-logo.png": "f3f7",
	"./university-texas-tyler-logo.png": "697d",
	"./uri-logo.png": "74c3",
	"./wv-logo-sm.jpg": "94cf",
	"./xavier-university-logo.png": "14cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0c";